<form>
  <mat-form-field class="input-field">
    <span matPrefix class="input-prefix">+91</span>
    <input matInput placeholder="Mobile number"
           [readonly]="isReadonly" [(ngModel)]="phoneNumber" name="phoneNumber"/>
    <button mat-stroked-button matSuffix class="btn-input-suffix" type="submit"
            (click)="sendOtp()" [disabled]="fieldDisabledTag || !validator.isMobilePhone(phoneNumber) || !isUserOnline() || !userUtil.isPanVerified()"
            *ngIf="!sendOtpLoader && !userUtil.isUserLoggedIn()">{{otpButton}}</button>
    <i matSuffix class="fa fa-check tick-input-suffix" aria-hidden="true" *ngIf="userUtil.isUserLoggedIn()"></i>
    <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="sendOtpLoader"></mat-spinner>
  </mat-form-field>

  <mat-form-field class="input-field" *ngIf="showOtp">
    <input matInput [(ngModel)]="otp" name="otp" placeholder="Enter the OTP" [maxLength]="6" type="password" />
    <button mat-stroked-button matSuffix class="btn-input-suffix" type="submit" [disabled]="!isUserOnline()" (click)="verifyOtpAndCreateUser(otp)" *ngIf="!verifyOtpLoader">VERIFY</button>
    <i matSuffix class="fa fa-check tick-input-suffix" aria-hidden="true" *ngIf="isUserCreated"></i>
    <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="verifyOtpLoader"></mat-spinner>
        <mat-error *ngIf="mobileError">{{mobileErrorMsg}}</mat-error>
  </mat-form-field>
  <small><mat-error *ngIf="errorMessage">{{errorMessage}}</mat-error></small>
</form>
